import {
  getUbmPriceElasticityGroup,
  type UbmPriceElasticityGroup,
} from '@smg-real-estate/toplisting-prices';

const UBM_PRICE_ELASTICITY_GTM_EXPERIMENT_ID = 'ASR-1346';
const UBM_PRICE_ELASTICITY_GTM_VARIANT_BY_GROUP: Record<UbmPriceElasticityGroup, string> = {
  Control: 'control',
  V1: 'variant1',
  V2: 'variant2',
};

function getNonProdFallbackGroup(
  customerId: string | undefined,
): UbmPriceElasticityGroup | undefined {
  return import.meta.env.VUE_APP_STAGE !== 'prod' && customerId === 'heia' ? 'Control' : undefined;
}

function getCustomerIdFromObjectReference(objectReference: string | undefined): string | undefined {
  const customerId = objectReference?.split('#')[0];

  return customerId || undefined;
}

/**
 * Builds GTM's `h_experiment_variant_array_048` value for the UBM price elasticity experiment.
 * The listing object-reference customer wins over the active agency id, then non-prod `heia`
 * falls back to control so PR/test playground tracking remains visible.
 */
export function getUbmPriceElasticityExperimentVariantArray({
  customerId,
  objectReference,
}: {
  customerId?: string;
  objectReference?: string;
}): string | undefined {
  const objectReferenceCustomerId = getCustomerIdFromObjectReference(objectReference);
  const group =
    getUbmPriceElasticityGroup(objectReferenceCustomerId) ??
    (objectReferenceCustomerId !== customerId
      ? getUbmPriceElasticityGroup(customerId)
      : undefined) ??
    getNonProdFallbackGroup(objectReferenceCustomerId ?? customerId);
  const variant = group ? UBM_PRICE_ELASTICITY_GTM_VARIANT_BY_GROUP[group] : undefined;

  return variant ? `${UBM_PRICE_ELASTICITY_GTM_EXPERIMENT_ID}=${variant}` : undefined;
}
